// funkce na nahrazeni input fieldu
export let selectOrNative = selector => {
  if (!Modernizr.touchevents) {
    $(selector).find('select').each((index, item) => {
      new Select({
          el: item,
          alignToHighlighted: 'always'
      });
    });
  }
  else {
    $(selector).find('select').each((index, item) => {
      $(item).selectTouch()
    })
  }
}

// replacement selectboxu, pokud mame touchscreen
function selectTouch() {
  var text = $('<span/>', {
    class: 'select-text',
    html: $(this).find('option:selected').text()
  }).insertBefore($(this))

  $(this).addClass('select-touch')

  $(this).change(function() {
    text.html($(this).find('option:selected').text())
  })
}



// WEBPACK FOOTER //
// ./app/form/select-or-native.js